<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="row">
        <div class="col-12 mb-4">
            <v-card>
                <v-card-title>
                    {{$t('intramwallets.management')}}
                    <v-spacer></v-spacer>
                    <!-- <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                    ></v-text-field> -->
                </v-card-title>


                <v-row class="pl-4 pr-4">
                  <v-text-field v-if="intramwallets===undefined" color="primary" loading
                                disabled></v-text-field>
                  <v-alert
                          style="margin-top: 1%"
                          v-else-if="intramwallets.length==0"
                          border="right"
                          colored-border
                          type="error"
                          elevation="2"
                          class="col-12"
                  >
                      {{$t('intramwallets.empty')}}
                  </v-alert>


                  <div @click="checkDetails(item._id)" v-for="(item,index) in intramwallets"  :key="index" class="col-sm-6 col-md-4" style="cursor: pointer">
                      <div class="card home-top-card" style="background: #29b3a6;
                      border-bottom: 3px solid white;color: white">
                          <div class="card-body" style="padding-top: 3px!important;
                          padding-bottom: 5px!important;border-top: 3px solid white;">
                              <div class=""><v-icon style="font-size: 22pt !important;"
                                small color="white">mdi-wallet-outline</v-icon>
                                  <span class="float-right home_top_number"
                                  style=" font-size: 15pt !important;">{{formatAmount(item._amount.$numberDecimal )}}</span><br/>
                                </div>

                              <h2 style=" font-size: 10pt !important; margin-top: 12%" class="text-uppercase">
                                {{item.devise._code_alpha}} - {{item.devise._name}}</h2>
                          </div>

                      </div>
                  </div>

                </v-row>

            </v-card>
        </div>
        <customsnackbar :snackbar="customSnack.snackbar"
        :text="customSnack.text"
        :snackcolor="customSnack.snackcolor" :snackbBtnColor="customSnack.snackbBtnColor"
        :snacktimeout="customSnack.snacktimeout" > </customsnackbar>
    </div>

</template>

<script>
    /* eslint-disable */
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    import helpers from "../../../../mixins/helpers";

    export default {

        label: "Reversements",
          mixins:[helpers(this)],
        data() {
            return {
                submitting: false,
                customSnack:{
                      snackbar: false,
                      text: "",
                      snackcolor:"black",
                      snackbBtnColor:"white",
                      snacktimeout:2000
                    },
                valid: true,
                lazy: false,
                errors: undefined,
                errors_means: null,
                errors_montant: null,
                itemSteps: [
                    "Mois", "Trimestre", "Semestre"
                ],
                search: '',
                dialog: '',
                dialogDetail: false,
                 note:"",
                id: undefined,
                step1: false,
                step2: false,
                step3: false,
                type: 'Mobile',
                generaldatas:{},
                devisedatas:{},
                e1: 1
            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? this.$t('reversements.newtext') : this.$t('reversements.update')
            }
            ,

            ...mapState('intramwallets/', ['intramwallets']),

        }
        ,
        mounted() {



            this.$store.dispatch('intramwallets/getIntramwallets').then(response => {
                window.console.log('intramwallets', response)
            });

        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {

            },
          checkDetails(wallet_id){
              this.$router.push({name:'intramwallets.details',params:{id:wallet_id}});
          },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },

        }
        ,
        created() {
            this.checkisDashboard();
            this.initialize()
        }
    }
</script>

<style scoped>
.btn-custom-add{
  border-radius: 33px;
  padding: 2%;
}
</style>
